module.exports = __webpack_public_path__ + "img/logo-elm.4681d05b.png";